import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useSidebar } from "../../Context/SidebarContext";

function Item({ icon, name, id, link, handleLogout, isSubMenu }) {
  const location = useLocation();
  const { open } = useSidebar();
  const isActive = location.pathname === link;

  return (
    <Link
      to={link}
      id={id}
      onClick={handleLogout}
      className={`flex items-center h-[35px] w-full rounded-[10px] mb-1.5 font-cairo text-[13px] no-underline
        transition-all duration-300 ease-in-out
        ${open ? "px-3 justify-start" : "px-0 justify-center"}
        ${
          isActive
            ? "bg-white text-secondaryColor"
            : "text-white hover:bg-white/30 hover:text-secondaryColor hover:-translate-x-1"
        }`}
    >
      <i
        className={`${isSubMenu && isActive ? "fa-regular fa-circle-dot" : icon} text-[20px] shrink-0 ${
          open ? "ml-3" : ""
        }`}
      />

      {open && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="whitespace-nowrap   "
        >
          {name}
        </motion.span>
      )}
    </Link>
  );
}

export default Item;